import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import { IUsernameModel } from 'src/app/services/users.service/users.service.models';

import { GlobalCommunication } from '../../../global-communication.service';
import { AuthService } from '../../../services/auth.service';
import { SettingsService } from '../../../services/settings.service';

@Component({
  templateUrl: './set-password.component.html',
  standalone: false,
})
export class SetPasswordComponent implements OnInit {
  public fullName: string = '';
  public user: { email: string } = { email: '' };
  public newPassword: string = '';
  public confirmPassword: string = '';
  public token: string = '';

  constructor(
    protected router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    public settings: SettingsService,
    public usersService: UsersService,
    private globalCommunication: GlobalCommunication,
  ) {}

  public ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.token = params.token;
      this.usersService.getFullName(this.token).subscribe((data: IUsernameModel) => {
        this.fullName = data.fullName;
      });
    });
  }

  public changePass(): void {
    this.authService.setPassword(this.newPassword, this.token).subscribe(() => {
      this.router.navigate(['/auth/login']);
      this.globalCommunication.showMessages([
        {
          severity: 'success',
          detail: 'Password was successfully set',
        },
      ]);
    });
  }
}
